import React from "react";
import Reviews from "../../componets/Reviews";
import testimonials from "../../data/testimonials2.json";

const Section9 = () => {
  return (
    <div className="w-full Section9 mt-[-20px] md:mt-[0px] p-[2%] py-0 md:py-[20px] text-center mb-[40px] md:mb-[3%] bg-cover">
      <div className="w-full section4-container">
        <Reviews testimonials={testimonials} />
      </div>
    </div>
  );
};

export default Section9;
